import { render, staticRenderFns } from "./sso_newbuildings.vue?vue&type=template&id=31211404&scoped=true"
import script from "./sso_newbuildings.vue?vue&type=script&lang=js"
export * from "./sso_newbuildings.vue?vue&type=script&lang=js"
import style0 from "./sso_newbuildings.vue?vue&type=style&index=0&id=31211404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31211404",
  null
  
)

export default component.exports